

const FilePreview = ({ publication_type,file, setFile }) => {
    return (
        <>
            {file && (
                <div className={`mt-6 mb-12 w-full ${publication_type === 'audio' || publication_type === 'doc' || publication_type === 'code' ? '' : 'h-[350px]'} rounded-[15px] relative mt-3 w-40 h-40 mx-auto`}>

                    {publication_type === "image" && (
                        <img
                            src={URL.createObjectURL(file)}
                            alt={URL.createObjectURL(file)}
                            className="w-full  rounded-[15px] w-full h-full object-contain"
                        />
                    )}
                    {publication_type === "pdf" && (
                        <iframe
                            src={`${URL.createObjectURL(file)}#toolbar=0`}
                            title={URL.createObjectURL(file)}
                            className="w-full  rounded-[15px] w-full h-full object-contain"
                        />
                    )}
                    {publication_type === "doc" && file && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <a
                                href={URL.createObjectURL(file)} // local blob URL
                                target="_blank"                 // open in new tab
                                rel="noopener noreferrer"       // security best practice
                                className="text-blue-600 hover:underline"
                            >
                                {file.name}
                            </a>
                        </div>
                    )}

                    {publication_type === "video" && (
                        <video
                            src={URL.createObjectURL(file)}
                            controls
                            className="w-full  rounded-[15px] w-full h-full object-contain"
                        />
                    )}

                    {publication_type === "audio" && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <audio src={URL.createObjectURL(file)} controls className="w-full  rounded-[15px] w-full object-contain" />
                        </div>

                    )}
                    {publication_type === "code" && file && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <a
                                href={URL.createObjectURL(file)} // creates local preview URL
                                //   download={file.name} // optional: lets user download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline"
                            >
                                {file.name}
                            </a>
                        </div>
                    )}



                    {/* Delete icon in a circle */}
                    <button
                        onClick={() => setFile(null)}
                        className="absolute top-1 right-1 w-6 h-6 bg-white rounded-full flex items-center justify-center shadow hover:bg-gray-200"
                        type="button"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            )}
        </>
    )
}

export default FilePreview